import React from "react";
import DonutChart from "@/charts/DonutChart";

const DonutAdapter = ({ spec, containerRef }) => {
  const { config = {}, data = [], title } = spec;
  const firstRow = data[0] || {};
  const rowKeys = Object.keys(firstRow);

  const keyColumn =
    config.keyColumn ||
    ["brand", "competitor", "name", "label", "topic", "key"].find((k) => k in firstRow) ||
    rowKeys.find((k) => typeof firstRow[k] === "string") ||
    rowKeys[0] ||
    "brand";

  const valueColumn =
    config.valueColumn ||
    ["share", "citations", "mentions", "count", "value", "total"].find((k) => k in firstRow) ||
    rowKeys.find((k) => k !== keyColumn && typeof firstRow[k] === "number") ||
    rowKeys.filter((k) => k !== keyColumn)[0] ||
    "share";

  const pinColumn =
    config.pinColumn ||
    ["is_client", "pin", "is_self", "is_own"].find((k) => k in firstRow) ||
    null;

  return (
    <div ref={containerRef} className="assistant-chart-render-wrapper donut-render-wrapper">
      <DonutChart
        data={data}
        title={title}
        keyColumn={keyColumn}
        valueColumn={valueColumn}
        pinColumn={pinColumn}
        isLoaded={true}
        height={config.height || 260}
        truncateSize={config.truncateSize || 6}
      />
    </div>
  );
};

export default DonutAdapter;
